import { createContext } from "react"

export type Teacher = {
  id: string
  ssoEmail: string
}

const TeacherContext = createContext<Teacher | Record<any, never>>({})

export default TeacherContext
